import React, { useState } from "react";

import PencilIcon from "@src/assets/icons/pencil.svg";
import { CardLabel } from "@src/components/card_label/index";
import { EditAdditionalInformationModal } from "@src/features/role_request_details/components/edit_additional_information_modal/index";
import { Card, Flex, Button } from "antd";
import "./additional_information_card.less";

import AdditionalInformationForm from "../additional_information_form/additional_information_form";

export interface AdditionalInformationCardProps {
  projectIdentifier: string;
  scope: string;
  specificRole: string;
  hasEditModal: boolean;
}

const AdditionalInformationCard: React.FC<AdditionalInformationCardProps> = ({
  projectIdentifier,
  scope,
  specificRole,
  hasEditModal,
}) => {
  const [showEditModal, setShowEditModal] = useState(false);

  /**
   * Renders the edit information button. This button will only be shown if the request is not a draft request.childRequest
   *
   * @return {React.ReactElement} - The rendered button jsx element
   */
  function renderEditAdditionalInformationButton(): React.ReactElement {
    return (
      hasEditModal && (
        <Button
          icon={<PencilIcon />}
          size="small"
          color="default"
          variant="filled"
          data-testid="edit-additional-information"
          onClick={() => setShowEditModal(true)}
        />
      )
    );
  }

  return (
    <>
      {showEditModal && (
        <EditAdditionalInformationModal
          showModal={showEditModal}
          onClose={() => setShowEditModal(false)}
        />
      )}
      <Card
        title="Additional Information"
        className={`info-card additional-information-card additional-information-card--${
          !hasEditModal ? "lg" : "sm"
        }`}
        extra={renderEditAdditionalInformationButton()}
      >
        {!hasEditModal ? (
          <AdditionalInformationForm
            projectIdentifier={projectIdentifier}
            scope={scope}
            specificRole={specificRole}
          />
        ) : (
          <Flex vertical gap={16}>
            <CardLabel label="Project identifier">
              {projectIdentifier}
            </CardLabel>
            <CardLabel label="Specific role">{specificRole}</CardLabel>
            <CardLabel label="Scope">{scope}</CardLabel>
          </Flex>
        )}
      </Card>
    </>
  );
};

export default AdditionalInformationCard;
